export default __webpack_public_path__ + "static/media/FAQ.081e2f04.png";